import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Added useLocation!
import appIcon from '../../assets/iconBox.svg'; 
import dashIcon from '../../assets/DashboardIcon.svg'; 
import mapIcon from '../../assets/MapIcon.svg'; 
import nodeIcon from '../../assets/NodeIcon.svg'; 
import userIcon from '../../assets/UserIcon.svg'; 
import outIcon from '../../assets/out.svg'; 
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userName, setUserName] = useState('Loading...');
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem('murjan_user');
    if (!storedUser) {
      setUserName('System Operator');
      return;
    }

    const user = JSON.parse(storedUser);
    setUserName(user.full_name || 'System Operator');
    setUserEmail(user.email || '');
    setUserRole(user.role || '');
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('murjan_token');
    localStorage.removeItem('murjan_user');
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path ? 'nav-item active' : 'nav-item';

  return (
    <aside className="sidebar-container">
      <div className="sidebar-profile">
        <div className="profile-avatar"><img src={appIcon} alt="Avatar" /></div>
        <div className="profile-info">
          <h3>{userName}</h3>
          <p>{userEmail}</p>
        </div>
      </div>

      <nav className="sidebar-nav">
        {/* Now the class dynamically changes based on the URL! */}
        <div className={isActive('/dashboard')} onClick={() => navigate('/dashboard')}>
          <div className="nav-icon"><img src={dashIcon} alt="Dashboard" /></div>
          <p>Dashboard</p>
        </div>
        
        <div className={isActive('/map')} onClick={() => navigate('/map')}>
          <div className="nav-icon"><img src={mapIcon} alt="Map" /></div>
          <p>Map</p>
        </div>

        <div className={isActive('/nodes')} onClick={() => navigate('/nodes')}>
          <div className="nav-icon"><img src={nodeIcon} alt="Nodes" /></div>
          <p>Nodes</p>
        </div>
        
        {userRole === 'admin' && (
          <div className={isActive('/users')} onClick={() => navigate('/users')}>
            <div className="nav-icon"><img src={userIcon} alt="Users" /></div>
            <p>Users</p>
          </div>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="nav-item logout" onClick={handleLogout}>
          <span className="nav-icon"><img src={outIcon} alt="Logout" /></span>
          <p>Logout</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
